import { NgModule } from '@angular/core';
import { CoreComponent } from './core.component';
import { StoreModule } from '@ngrx/store';
import { coreEffects } from './store/effects';
import { EffectsModule } from '@ngrx/effects';
import { reducers } from './store/reducers';

@NgModule({
  declarations: [CoreComponent],
  imports: [StoreModule.forRoot(reducers), EffectsModule.forRoot(coreEffects)],
  exports: [CoreComponent],
})
export class CoreModule {}
